module.exports = __webpack_public_path__ + "static/media/calendar.85558e7d.svg";